<template>
  <div class="result" v-if="!loading">
    <v-layout align-center justify-end row wrap c>
      <v-btn color="cyan" class="white--text" @click="openPrintPage">
        <v-icon color="white">print</v-icon>印刷ページを開く
      </v-btn>
      <v-btn color="green" class="white--text" @click="getResult(true)">
        <v-icon color="white">refresh</v-icon>再集計
      </v-btn>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12 sm5>
        <info-table :infoItems="result.info" />
      </v-flex>
      <v-flex xs12 sm6 offset-sm1>
        <summary-table
          :values="result.summary"
          :ops="result.select_options"
          :categories="result.select_categories"
        />
      </v-flex>
    </v-layout>
    <v-layout align-center justify-center row wrap class="result-row">
      <all-chart :items="accountData" @plot-done="plotDone" />
    </v-layout>
    <v-tabs v-model="active" color="cyan" dark slider-color="yellow">
      <v-tab>全分類</v-tab>
      <v-tab v-for="c in result.select_categories" :key="c" ripple>{{
        c
      }}</v-tab>
      <v-tab>優れているところ/良いと思うところ</v-tab>
      <v-tab>改善してほしいところ</v-tab>
      <v-tab>期待していること</v-tab>
      <v-tab-item>
        <result-table
          :values="result.select_questions"
          :ops="result.select_options"
          ref="all"
        />
      </v-tab-item>
      <v-tab-item v-for="c in result.select_categories" :key="c">
        <result-table
          :values="result.select_questions.filter((item) => item.category == c)"
          :ops="result.select_options"
        />
      </v-tab-item>
      <v-tab-item>
        <comment-list
          :comments="result.comment_questions[2].comments"
          :isShow="result.comment_questions[2].isShow"
        />
      </v-tab-item>
      <v-tab-item>
        <comment-list
          :comments="result.comment_questions[3].comments"
          :isShow="result.comment_questions[3].isShow"
        />
      </v-tab-item>
      <v-tab-item>
        <comment-list
          :comments="result.comment_questions[4].comments"
          :isShow="result.comment_questions[4].isShow"
        />
      </v-tab-item>
    </v-tabs>
  </div>
</template>


<script>
import AllChart from "@/components/results/all_chart.vue";
import ResultTable from "@/components/results/result_table.vue";
import SummaryTable from "@/components/results/summary_table.vue";
import InfoTable from "@/components/results/info_table.vue";
import CommentList from "@/components/results/comment_list.vue";
import { mean, standardDeviation, max } from "simple-statistics";
import { roundAndToFixed, frequency } from "@/utils/statics.js";
import Plotly from "plotly.js-dist";
import { makeDoc } from "@/components/pdf/jsPdf";
import html2canvas from "html2canvas";
import db from "@/components/firebaseInit";
import { mapGetters, mapActions, mapMutations } from "vuex";

export default {
  components: {
    AllChart,
    ResultTable,
    SummaryTable,
    InfoTable,
    CommentList,
  },
  data() {
    return {
      items: [],
      active: null,
      categories: [],
      selectOptions: [],
      summary: { avgSelf: null, avgScore: null, sdScore: null },
      summaryItems: {},
      answers: [],
      survey: null,
      questions: [],
      selectSections: [],
      commentSections: [],
      infoItems: {
        subjectName: "",
        startDate: "",
        endDate: "",
        numOfCoWorker: 0,
      },
      loading: true,
      result: {},
      surveyDbRef: db
        .collection("companies")
        .doc(this.$route.params.company_id)
        .collection("surveys")
        .doc(this.$route.params.survey_id),
      answerDbRef: db
        .collection("companies")
        .doc(this.$route.params.company_id)
        .collection("surveys")
        .doc(this.$route.params.survey_id)
        .collection("answer_sheets"),
      resultsDbRef: db
        .collection("companies")
        .doc(this.$route.params.company_id)
        .collection("surveys")
        .doc(this.$route.params.survey_id)
        .collection("results"),
    };
  },
  mounted() {
    this.loading = true;
    this.getResult();
  },
  methods: {
    async getResult(doForceTheAccount = false) {
      const doc = await this.resultsDbRef.doc(this.$route.params.user_id).get();
      if (!doForceTheAccount && doc.exists) {
        this.result = doc.data();
        this.loading = false;
      } else {
        this.accountResults();
      }
    },
    async accountResults() {
      this.changeLoadingState(true);
      this.answers = [];
      const querySnapshot = await this.answerDbRef
        .where("subject_id", "==", this.$route.params.user_id)
        .get();
      querySnapshot.forEach((doc) => {
        const ans = doc.data();
        if ((ans.status && ans.status == "完了") || ans.status == "完了前") {
          this.answers.push(ans);
        }
      });
      this.getSurvey();
    },
    async getSurvey() {
      const doc = await this.surveyDbRef.get();
      this.survey = doc.data();
      this.commentSections = { index: [] };
      this.questions = [];
      this.survey.question_sheet.sections
        .filter((s, i) => {
          if (s.type == "SelectQuestions") {
            this.selectSections.push(i);
            return true;
          } else if (s.type == "CommentQuestions") {
            this.commentSections.index.push(i);
            this.commentSections[i] = {
              isShow: s.isShow,
              comments: { subject: [], coWorker: [] },
            };
          }
        }, this)
        .forEach((s) => {
          s.questions.forEach((q) => this.questions.push(q));
        });
      this.categories =
        this.survey.question_sheet.sections[
          this.selectSections[0]
        ].categoryList;
      this.categories.forEach((c) => {
        this.summaryItems[c] = { category: c, selfs: [], score: [] };
      });
      this.selectOptions =
        this.survey.question_sheet.sections[
          this.selectSections[0]
        ].selectOptions;
      this.account();
    },
    account() {
      const subjectAns = this.answers.filter((a) => a.type == "subject")[0];
      const coWorkerAns = this.answers.filter((a) => a.type == "coWorker");

      //account select questions
      this.items = this.questions.map((q) => {
        const score = [];
        coWorkerAns.forEach((a) => {
          if (a.result[this.selectSections[0]][q.id]) {
            const s = Number(a.result[this.selectSections[0]][q.id]);
            this.summaryItems[q.category].score.push(s);
            score.push(s);
          }
        }, this);
        const self = Number(subjectAns.result[this.selectSections[0]][q.id]);

        this.summaryItems[q.category].selfs.push(self);

        return {
          id: q.id,
          question: q.question,
          category: q.category,
          score: score,
          self: self,
        };
      });

      //account coWorker's comments
      coWorkerAns.forEach((a) => {
        this.commentSections.index.forEach((i) => {
          if (a.result[i].length > 0) {
            this.commentSections[i].comments.coWorker.push(
              ...a.result[i].filter((c) => c.trim().length > 0)
            );
          }
          debugger;
          //Random sort comments
          for (
            let j = this.commentSections[i].comments.coWorker.length - 1;
            j > 0;
            j--
          ) {
            const rand = Math.floor(Math.random() * (j + 1));
            [
              this.commentSections[i].comments.coWorker[j],
              this.commentSections[i].comments.coWorker[rand],
            ] = [
              this.commentSections[i].comments.coWorker[rand],
              this.commentSections[i].comments.coWorker[j],
            ];
          }
        });
      });

      //account subject's comments
      this.commentSections.index.forEach((i) => {
        if (subjectAns.result[i].length > 0) {
          this.commentSections[i].comments.subject.push(
            ...subjectAns.result[i].filter((c) => c.length > 0)
          );
        }
      });

      //account info table
      this.infoItems.subjectName = subjectAns.subject_name;
      this.infoItems.startDate = this.survey.start_date;
      this.infoItems.endDate = this.survey.pre_end_date;
      this.infoItems.numOfCoWorker = coWorkerAns.length;
      this.loading = false;

      const subjectInfo = JSON.parse(JSON.stringify(subjectAns));
      delete subjectInfo.result;

      this.changeLoadingState(false);
      this.result = {
        select_questions: this.items,
        select_options: this.selectOptions,
        select_categories: this.categories,
        comment_questions: this.commentSections,
        summary: this.summaryItems,
        info: this.infoItems,
        subject: subjectInfo,
      };

      this.resultsDbRef
        .doc(this.$route.params.user_id)
        .set(this.result)
        .then((doc) => {})
        .catch((e) => {
          console.error(e);
        });
    },
    async plotDone(plot) {
      this.allChartUrl = await Plotly.toImage(plot, {
        format: "png",
        width: 1600,
        height: 800,
      });
    },
    distribution(score) {
      let dist = Array(this.result.select_options.length).fill(0);
      score.forEach((e) => (dist[e - 1] = dist[e - 1] + 1));
      return dist;
    },
    openPrintPage() {
      let routeData = this.$router.resolve({
        name: "print_result",
        params: {
          company_id: this.$route.params.company_id,
          survey_id: this.$route.params.survey_id,
          user_id: this.$route.params.user_id,
        },
      });
      window.open(routeData.href, "_blank");
    },
    ...mapMutations("app", ["changeLoadingState"]),
  },
  computed: {
    summaryCategorys() {
      const categories = {};
      const all = { self: [], score: [] };
      this.result.select_questions.forEach((item) => {
        if (!(item.category in categories)) {
          categories[item.category] = { self: [], score: [] };
        }
        categories[item.category].self.push(item.self);
        Array.prototype.push.apply(categories[item.category].score, item.score);

        all.self.push(item.self);
        Array.prototype.push.apply(all.score, item.score);
      });
      this.summary.avgSelf = roundAndToFixed(mean(all.self), 2);
      this.summary.avgScore = roundAndToFixed(mean(all.score), 2);
      this.summary.sdScore = roundAndToFixed(standardDeviation(all.score), 2);

      for (let c in categories) {
        categories[c].avgSelf = roundAndToFixed(mean(categories[c].self), 2);
        categories[c].avgScore = roundAndToFixed(mean(categories[c].score), 2);
        categories[c].sdScore = roundAndToFixed(
          standardDeviation(categories[c].score),
          2
        );
      }
      return categories;
    },
    accountData() {
      var d3colors = Plotly.d3.scale.category10();
      return this.result.select_questions.map((v) => {
        const avg = roundAndToFixed(mean(v.score), 2);
        console.log(v.id);
        console.log(v.score);
        console.log(avg);
        return {
          id: v.id,
          category: v.category,
          color: d3colors(this.result.select_categories.indexOf(v.category)),
          question: v.question,
          self: v.self,
          score: v.score,
          meanScore: avg,
          diffSelfAndmeanScore: roundAndToFixed(avg - v.self, 2),
          sdScore: roundAndToFixed(standardDeviation(v.score), 2),
          frequency: frequency(v.score, this.result.select_options.length),
        };
      });
    },
    ...mapGetters("auth", ["isLoggedIn", "user"]),
  },
};
</script>

<style lang="scss" scoped>
.result-row {
  margin: 10px 0;
}
</style>
